export default {
  title: 'Checking offers',
  subtitle: 'Just a moment while we double check the offers.',
}
